import { render } from "./MarketPulseWidget.vue?vue&type=template&id=3857bed0&scoped=true"
import script from "./MarketPulseWidget.vue?vue&type=script&lang=js"
export * from "./MarketPulseWidget.vue?vue&type=script&lang=js"

import "./MarketPulseWidget.vue?vue&type=style&index=0&id=3857bed0&scoped=true&lang=scss"

import exportComponent from "/var/www/production/releases/343/listings.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3857bed0"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QIcon,QSelect,QSkeleton});
